import { render, staticRenderFns } from "./pad_paper_detail_list.vue?vue&type=template&id=167e02d2&scoped=true"
import script from "./pad_paper_detail_list.vue?vue&type=script&lang=js"
export * from "./pad_paper_detail_list.vue?vue&type=script&lang=js"
import style0 from "./pad_paper_detail_list.vue?vue&type=style&index=0&id=167e02d2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167e02d2",
  null
  
)

export default component.exports